import React, { Component } from 'react';
import {getColor} from "../styles";

export default class LinearGauge extends Component {
    createStyle(val, colors, color) {
        return {
            width: `${val}%`,
            backgroundColor:  colors ? getColor(colors, color, 99) : "black",
            backgroundImage: 'none'
        };
    }

    getPercentage(value) {
        return (value - this.props.min) / (this.props.max - this.props.min) * 100;
    }

    render() {
        let height = this.props.height || 20;
        let pointerWidth = this.props.pointerSize || height / 2.0;
        let pointerHeight = pointerWidth;
        let percentages = [];
        let pointerStyles = [];
        let pointers = [];

        const b = {
            "width": "2px",
            "height": `${height}px`,
            marginLeft: `${pointerWidth / 2.0}px`,
            marginBottom: `-${height}px`,
            background: "#777",
        };

        const point = {
            width: 0,
            height: 0,
            borderTop: `${height}px solid transparent`,
            borderBottom: `${pointerHeight}px solid #777`,
            borderLeft: `${pointerWidth / 2.0}px solid transparent`,
            borderRight: `${pointerWidth / 2.0}px solid transparent`,
            position: 'relative',
            left: '1px'
        };

        const barStyle = {
            height: `${height}px`
        };

        let { ranges } = this.props;
        if (ranges === undefined) {
            ranges = {
                green: { min: 0, max: 0 },
                orange: { min: 0, max: 0 },
                red: { min: 0, max: 0 }
            }
        }

        // need another div to wrap the progress bar
        // to set the position: absolute reference (bar and arrow section)
        // to the bar. Without this - the absolute will not take into account the 
        // padding put in by the column styles
        const topLevelStyle = {
            position: 'relative'
        };

        const boxStyle = {
            width: "22px",
            height: "22px",
            left: "-5px",
            position:  "relative",
            borderColor: "grey",
            borderWidth: "2px",
            fontSize: "14px",
            borderStyle: "solid",
            textAlign:  "center",
            fontWeight: "600",
            borderRadius: "20%"
        };

        for (let index = 0; index < this.props.values.length; index++) {
            const val = this.getPercentage(this.props.values[index]);
            percentages.push(val);

            const s = {
                "height": `${height}px`,
                position: "absolute",
                top: 0,
                right: `${100 - val}%`
            };

            pointerStyles.push(s);

            let valueLabel = this.props.valueLabels[index];
            if (val) {
                pointers.push(
                    <div style={s} title={val} key={index}>
                        <div style={{ left: `15px`, position: 'relative' }}>
                            <div style={b} />
                            <div style={point} />
                            <div style={boxStyle}>
                                {valueLabel}
                            </div>
                        </div>
                    </div>); 
            }
        }
        
        let bars;
        let i =0;
        let lastMax = 0;
        if (this.props.ranges) {

            bars = [];
            for (let range of this.props.ranges) {
                let val = 0;
                // if upper bounds is inf - take all remaining space
                if (range.range.max === Number.MAX_VALUE) {
                    val = 100 - lastMax;
                }
                else 
                {
                    val = 100 *(range.range.max - this.props.min)/ Math.abs(this.props.max - this.props.min);
                    val = val - lastMax;
                }
                let style = this.createStyle(val, this.props.colors, range.color);
                let barPart = (<div className="progress-bar"
                            role="progressbar"
                            key={i}
                            style={style}/>);
                bars.push(barPart);
                            
                i++;
                lastMax += val;
            }
        }

        return (
            <div style={topLevelStyle}>
                <div className="progress" style={barStyle}>
                    {bars || ""}
                    {pointers}
                </div>
            </div>
        );
    }
} 


// WEBPACK FOOTER //
// ./src/components/LinearGauge/LinearGauge.js